export const storeKeys = {
  all: ['org', 'stores'] as const,
  list: () => [...storeKeys.all, 'list'] as const,
  detail: (id: string) => [...storeKeys.all, 'detail', id] as const,
  readiness: (id: string) => [...storeKeys.all, 'readiness', id] as const,
  timezones: () => ['meta', 'timezones'] as const,
};
